import SuccessMessage from '@kopapro/components/commons/successMessage/successMessage';

export default SuccessMessage;
